import React from "react";
import { Item, Ref } from "semantic-ui-react";
import { MarkerIcon } from "../constants/markers";
import Truncate from "react-truncate";

type CaseListProps = {
  cases: Array<Record<string, unknown>>;
  caseHovered?: any;
  caseSelected?: any;
  onListItemHovered?: { (caseObj: any): void };
  onListItemClicked?: { (caseObj: any): void };
};

class CaseList extends React.Component<CaseListProps> {
  scrolledToCase?: string;
  listRefs: {
    [key: string]: any;
  };

  constructor(props: CaseListProps) {
    super(props);
    this.listRefs = {};
  }

  componentDidUpdate() {
    if (!this.props.caseSelected) {
      return;
    }

    const {
      record: { caseid },
    } = this.props.caseSelected;
    if (this.scrolledToCase !== caseid) {
      this.listRefs[caseid].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      this.scrolledToCase = caseid;
    }
  }

  renderContact(contactName: string | null) {
    if (!contactName) {
      return null;
    }
    return <p>Contact: {contactName}</p>;
  }

  renderListItem(caseObj: any) {
    const { record } = caseObj;
    const iconUrl = (record.status === "Closed" ? MarkerIcon.green : MarkerIcon.red).url;
    const clearHovered = () => {
      return () => {
        if (this.props.onListItemHovered) {
          this.props.onListItemHovered(null);
        }
      };
    };

    const onListItemHovered = (caseObj: any) => {
      return () => {
        if (this.props.onListItemHovered) {
          this.props.onListItemHovered(caseObj);
        }
      };
    };
    const onListItemClicked = (caseObj: any) => {
      return () => {
        if (this.props.onListItemClicked) {
          this.props.onListItemClicked(caseObj);
        }
      };
    };

    const handleRef = (ref: any) => {
      this.listRefs[record.caseid] = ref;
    };

    return (
      <Ref innerRef={handleRef} key={record.caseid}>
        <Item
          onMouseEnter={onListItemHovered(caseObj)}
          onMouseLeave={clearHovered}
          onClick={onListItemClicked(caseObj)}
        >
          <Item.Image size='mini' src={iconUrl} />
          <Item.Content>
            <Item.Header as='a'>
              {record.object} #{record.displayId}
            </Item.Header>
            <Item.Meta>
              <b>{record.topic}</b>
            </Item.Meta>
            <Item.Meta>{record.location}</Item.Meta>
            <Item.Description>
              <Truncate lines={3}>{record.requestDescription}</Truncate>
            </Item.Description>
            <Item.Extra>{this.renderContact(record.contactName)}</Item.Extra>
          </Item.Content>
        </Item>
      </Ref>
    );
  }

  render() {
    const { cases } = this.props;
    return (
      <Item.Group divided relaxed>
        {cases.map(this.renderListItem, this)}
      </Item.Group>
    );
  }
}

export default CaseList;
